<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="student_type_list" :search="search" class="elevation-1 mytable" dense>
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Student Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"></span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12"></v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line
                hide-details></v-text-field>
            </v-col>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Student Type</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          
                          <v-text-field v-model="editedItem.name"  :rules="[
                            (v) => !!v || 'Name is required', 
                            (v) => (v && v.length <= 50) || 'Name must be less than 50 characters'
                          ]" label="Student Type" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-checkbox v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <!-- <v-avatar style=""  class="edit-avatar"> -->
              <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">edit</v-icon>
            <!-- </v-avatar> -->
            <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">mdi-delete</v-icon>
          </div>
        </template>
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    data: () => ({
      valid: false,
      overlay: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Active",
          align: "left",
          sortable: true,
          value: "isactive",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      student_type_list: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        name: "",
        isactive: true,
      },
      defaultItem: {
        id: null,
        name: "",
        isactive: true,
      },
    }),

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "New Student Type" : "Edit Student Type";
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    mounted() {
      this.onLoad();
    },

    methods: {
      onLoad() {
        this.overlay = true;
        axios
          .get("/AdmissionMaster/getStudentType")
          .then((res) => {
            this.overlay = false;
            if (res.data.student_type_list) {
              this.student_type_list = res.data.student_type_list;
            } else if (res.data.msg && (res.data.msg === "401" || res.data.msg === "403")) {
              this.showSnackbar("#b71c1c", "Unauthorized access");
            } else if (res.data.msg === "404") {
              this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
            } else {
              this.showSnackbar("#b71c1c", "Failed to load Student Types");
            }
          })
          .catch((error) => {
            this.overlay = false;
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error(error);
          });
      },

      editItem(item) {
        this.editedIndex = this.student_type_list.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        if (!confirm(`Are you sure you want to delete Student Type '${item.name}'?`)) return;
        axios
          .post("/AdmissionMaster/deleteStudentType", { deleteid: item.id, name: item.name })
          .then((res) => {
            if (res.data.status && res.data.status.code === "SUCCESS") {
              this.showSnackbar("#4caf50", "Student Type Deleted Successfully");
              this.onLoad();
            } else {
              this.showSnackbar("#b71c1c", res.data.status ? res.data.status.message : "Failed to delete Student Type");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            console.error(error);
          });
      },

      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      save() {
        if (!this.valid) return;

        const payload = {
          name: this.editedItem.name.trim(),
          isactive: this.editedItem.isactive,
        };

        if (this.editedIndex > -1) {
          // Edit
          payload.editid = this.editedItem.id;
          axios
            .post("/AdmissionMaster/editStudentType", payload)
            .then((res) => {
              if (res.data.status && res.data.status.code === "SUCCESS") {
                Object.assign(this.student_type_list[this.editedIndex], this.editedItem);
                this.showSnackbar("#4caf50", "Student Type Updated Successfully");
              } else if (res.data.status && res.data.status.code === "NA") {
                this.showSnackbar("#b71c1c", res.data.status.message);
              } else if (res.data.msg === "404") {
                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
              } else {
                this.showSnackbar("#b71c1c", "Failed to update Student Type");
              }
            })
            .catch((error) => {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              console.error(error);
            });
        } else {
          // Save new
          axios
            .post("/AdmissionMaster/saveStudentType", payload)
            .then((res) => {
              if (res.data.status && res.data.status.code === "SUCCESS") {
                this.showSnackbar("#4caf50", "Student Type Added Successfully");
                this.onLoad();
              } else if (res.data.status && res.data.status.code === "NA") {
                this.showSnackbar("#b71c1c", res.data.status.message);
              } else if (res.data.msg === "404") {
                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
              } else {
                this.showSnackbar("#b71c1c", "Failed to add Student Type");
              }
            })
            .catch((error) => {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              console.error(error);
            });
        }
        this.close();
      },
    },
  };
</script>

<style scoped>
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }

  .v-icon-size {
    font-size: 20px;
  }

  .edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
  }

  .edit-avatar:hover {
    background-color: #b0bec5;
  }

  .edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
  }

  .edit-v-icon:hover {
    color: white;
  }
</style>